import { inject as service } from '@ember/service';
import DeliveriesController from 'cio/controllers/deliveries';
import AuthService from 'cio/services/auth';

export default class OutboxListDeliveriesController extends DeliveriesController {
  filterQueryParams = ['campaign', 'action', 'recipient'];
  queryParams = ['actionType', 'campaign', 'startTs', 'endTs', 'action', 'recipient', 'deliveryStatus'];

  @service auth!: AuthService;

  get hasReadOnlyPermission() {
    return !this.auth.hasPermission('journeys/messages/send');
  }
}
